module.exports = __webpack_public_path__ + "static/media/dayBookSmall.2e1bf2c2.png";